import HasSourceObject from "@mapmycustomers/shared/types/base/HasSourceObject";
import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";
import Funnel from "@mapmycustomers/shared/types/entity/deals/Funnel";
import Stage from "@mapmycustomers/shared/types/entity/deals/Stage";
import FormLayout, { ChildLayout } from "@mapmycustomers/shared/types/layout/FormLayout";

export type Variant =
  | {
      activityTypeId: ActivityType["id"];
    }
  | {
      childLayoutId: ChildLayout["id"];
    }
  | {
      funnelId: Funnel["id"];
      stageId: Stage["id"];
    }
  | {
      sourceObject: HasSourceObject["sourceObject"];
    };

const getChildLayout = (layout: FormLayout, variant?: Variant): ChildLayout | undefined => {
  const childLayouts = layout.childLayouts;
  if (!childLayouts?.length || !variant) {
    return undefined;
  }

  if ("childLayoutId" in variant) {
    return childLayouts.find((child) => child.id === variant.childLayoutId);
  }

  if ("activityTypeId" in variant) {
    return childLayouts.find((child) => child.crmActivityType?.id === variant.activityTypeId);
  }

  if ("funnelId" in variant && "stageId" in variant) {
    return childLayouts.find(
      (child) => child.stage?.id === variant.stageId && child.funnel?.id === variant.funnelId
    );
  }

  if ("sourceObject" in variant) {
    // null is the standard object — a real value
    return childLayouts.find(
      (child) => (child.sourceObject ?? null) === (variant.sourceObject ?? null)
    );
  }

  return undefined;
};

export default getChildLayout;
